import React, { memo, useContext } from 'react';

import StatusReason from './StatusReason';
import TransactionContext from '../contexts/TransactionContext';
import AdImage from './AdImage';
import AdTitle from './AdTitle';
import Status from './Status';
import StatusInfo from './StatusInfo';
import useGetUserType from '../../hooks/useGetUserType';

import S from './style/AdBlock';

interface OrderCardResponsiveProps {
  active: boolean;
  onTitleClick: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  packageDeliveryInfoUrl: string;
  packageDeliveryBuyerManualUrl: string;
  packageDeliverySellerManualUrl: string;
  showOrderSafeDealPackageDeliveredDescr: boolean;
  goToReturns?: () => void;
}

const AdBlock: React.FC<OrderCardResponsiveProps> = ({
  active,
  onTitleClick,
  packageDeliveryInfoUrl,
  packageDeliveryBuyerManualUrl,
  packageDeliverySellerManualUrl,
  showOrderSafeDealPackageDeliveredDescr,
  goToReturns,
}) => {
  const transaction = useContext(TransactionContext);
  const { status = '', ad } = transaction || {};

  const { isSeller } = useGetUserType({
    buyerId: transaction?.buyer?.userId,
    sellerId: transaction?.seller?.userId,
  });

  const isPostingMethodExternalApp =
    (transaction?.shipment as any)?.postingMethod === 'EXTERNAL_APP' &&
    transaction.status === 'SHIPMENT_LABEL_RECEIVED' &&
    isSeller;

  return (
    <>
      <S.Block>
        <AdImage src={ad?.image} />
        <AdTitle active={active} onTitleClick={onTitleClick} isSeller={isSeller} />
      </S.Block>
      <Status status={status} transaction={transaction} />
      <StatusReason statusReason={transaction?.statusReason} />
      <StatusInfo
        status={status}
        packageDeliveryInfoUrl={packageDeliveryInfoUrl}
        packageDeliveryBuyerManualUrl={packageDeliveryBuyerManualUrl}
        packageDeliverySellerManualUrl={packageDeliverySellerManualUrl}
        showOrderSafeDealPackageDeliveredDescr={showOrderSafeDealPackageDeliveredDescr}
        isPostingMethodExternalApp={isPostingMethodExternalApp}
        goToReturns={goToReturns}
        statusChangeTime={transaction?.statusChangeTime}
        deliveryType={transaction?.deliveryType}
      />
    </>
  );
};

export default memo(AdBlock);
